export default __webpack_public_path__ + "49d51313448ea4953e809aade38ee2e7.svg";